import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { AppShell } from "@/components/AppShell";
import { supabase } from "@/integrations/supabase/client";
import { fetchOnboardingState, onboardingStateKey } from "@/lib/onboarding-state";
import { meetSetupHref, needsOnboarding, type OnboardingState } from "@/lib/post-auth";

export const Route = createFileRoute("/_authenticated")({
  ssr: false,
  beforeLoad: async ({ context, location }) => {
    const { data, error } = await supabase.auth.getUser();
    if (error || !data.user) {
      if (typeof window !== "undefined") {
        try {
          const url = new URL(window.location.href);
          // Пригласительная ссылка в круг: сохраняем ref и куда вернуться после входа.
          const m = url.pathname.match(/^\/circles\/([0-9a-f-]{36})\/?$/i);
          const ref = url.searchParams.get("ref");
          if (m && ref) {
            const { storeCircleRef } = await import("@/lib/circle-invite");
            storeCircleRef(m[1], ref);
          }
          const { setRedirectIntent } = await import("@/lib/redirect-intent");
          setRedirectIntent(url.pathname + url.search);
        } catch {
          /* ignore */
        }
      }
      throw redirect({ to: "/auth" });
    }
    // Замок онбординга. Ошибка запроса не блокирует (fail open).
    let state: OnboardingState | null = null;
    try {
      state = await context.queryClient.ensureQueryData({
        queryKey: onboardingStateKey(data.user.id),
        queryFn: () => fetchOnboardingState(data.user.id),
        staleTime: 60_000,
      });
    } catch {
      state = null;
    }
    // Замок только на Знакомство и Кофе — открываем мини-мастер «Знакомство» с возвратом.
    if (needsOnboarding(state, location.pathname, location.search as Record<string, unknown>)) {
      throw redirect({ href: meetSetupHref(location.href) });
    }
    return { user: data.user };
  },

  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
